export const environment = {
  production: true,
  name: 'dev',
  baseUrl: 'https://univerge.celloscope.net/api',
  // reportUrl: 'https://univerge.celloscope.net/report',
  updated_on: '2024-Sep-18',
  apiUrl: 'https://univerge.celloscope.net'
};
